import { useEffect, useState } from "react";
import { Button } from "../../components/ui/button";
import welcome from "../../assets/images/truck-image.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { Loader } from "lucide-react";
import requestErrorHandler from "../../util/requestErrorHandler";

export function WelcomePage() {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const {user, getLoggedIn} = useAuth();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setIsLoading(true)
        localStorage.setItem("token", token!);
        await getLoggedIn(() => {}, token!);
      } catch (error) {
        requestErrorHandler(error);
        console.error("Error fetching user data:", error);
      } finally {
        setIsLoading(false)
      }
    }
    // Check if token exists in the URL
    if (!token) {
      navigate("/signin");
    } else {
      fetchUserData();
    }
  }, [token, navigate, getLoggedIn]);

  const handleRedirect = () => {
    if (user) {
      navigate("/vehicles");
      return;
    }
    navigate("/signin");
  }

  return (
    <div className="max-w-3xl h-full mx-auto flex flex-col justify-center items-center p-4 md:p-8 space-y-8">
      <h1 className="text-2xl font-bold mb-4 ">Welcome to GoDump</h1>

      <h2 className=" font-medium ">You can now setup your fleet </h2>
      <div className="flex flex-col items-center space-y-8 md:w-1/2">
        <img src={welcome} width={500} alt="welcome" />

        <Button onClick={() => handleRedirect()} className="w-full bg-blue-600 hover:bg-blue-700" disabled={isLoading}>
          {isLoading ? (<Loader />) : 'Complete Setup'}
        </Button>
      </div>
    </div>
  );
}
